import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import '../styles/auth.css';
import { getApiUrl, getCsrfToken } from '../utils/apiHelper';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Verification token is missing from the URL');
      return;
    }

    const verify = async () => {
      setStatus('loading');
      setMessage('');

      try {
        const csrfToken = await getCsrfToken();
        const response = await fetch(getApiUrl('/api/internal/auth/verify-email/'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken,
          },
          credentials: 'include',
          body: JSON.stringify({ token }),
        });

        const data = await response.json().catch(() => ({}));

        if (data.success) {
          setStatus('success');
          setMessage(data.message || 'Email has been verified successfully');

          // After a short delay, send the user to login
          setTimeout(() => {
            navigate('/login');
          }, 2000);
        } else {
          setStatus('error');
          setMessage(
            data.message || 'Invalid or expired verification token'
          );
        }
      } catch (err) {
        setStatus('error');
        setMessage('An error occurred while verifying your email');
      }
    };

    verify();
  }, [searchParams, navigate]);

  const isLoading = status === 'loading';

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>Verify Email</h2>
          <p>
            {isLoading
              ? 'Verifying your email, please wait...'
              : 'Email verification status'}
          </p>
        </div>

        <div className="auth-form">
          {status === 'error' && (
            <div className="error-message">
              {message || 'Verification failed.'}
            </div>
          )}
          {status === 'success' && (
            <div className="success-message">
              {message || 'Email has been verified successfully'}
            </div>
          )}
          {isLoading && (
            <div className="info-message">
              Checking your verification link...
            </div>
          )}

          {!isLoading && (
            <button
              type="button"
              className="auth-button"
              onClick={() => navigate('/login')}
            >
              Go to Login
            </button>
          )}
        </div>

        <div className="auth-footer">
          <p>
            Need to sign in again?{' '}
            <Link to="/login" className="auth-link">
              Go to login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

